"use client"
import * as React from "react"
import { TrendingUp } from "lucide-react"
import { Bar, BarChart, CartesianGrid, XAxis, LabelList } from "recharts"
import { addDays, subDays, format, subMonths, addMonths, startOfToday, endOfToday } from "date-fns";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/Card"
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "../../components/ui/chart"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
  } from "../../components/ui/Select"
// import {  } from "./DateRangePicker"
// import { DatePickerWithRange } from "./DateRangePicker"
// import { DatePickerDemo } from "./DateRangePicker"
// import { DatePickerWithRange } from "./DateRangePicker"
import { DatePickerWithRange } from "./ShadDateRangePicker"
import { DatePicker } from "./ShadDatePicker";
import { Button } from "../ui/Button";
// import { MyDatePicker } from "./dayPicker"
// import { el } from "date-fns/locale";
// import { use } from "react";

// Custom label rendered on top of each stacked bar showing the total sum
const CustomTotalLabel = ({ x, y, width, index, chartData, chartConfig }) => {
  if (!chartData || !chartData[index]) return null;
  const total = Object.keys(chartConfig).reduce((sum, key) => sum + (chartData[index][key] || 0), 0);
  if (total === 0) return null;
  return (
    <text
      x={x + width / 2}
      y={y - 7}
      textAnchor="middle"
      fill="#374151"
      fontSize={12}
      fontWeight="500"
    >
      {total.toLocaleString()}
    </text>
  );
};

export function Component({ date,  cardTitle, cardDescription, chartConfig, chartData, handleDateSelect, calenderStartDate, calenderEndDate, calenderComponentDisabled, buttonText, handleDateSubmit, showTotal=true }) {
  console.log(   chartData , "chartDataaa");
  
  // // const [activeMonth, setActiveMonth] = React.useState(deviceNames[0]);
  // const today = startOfToday();
  // const endToday = endOfToday();
  // const [date, setDate] = React.useState({
  //   from: subDays(today, 7),
  //   to: endToday, // Default to a week from today
  // });

  // React.useEffect(() => {
  //   console.log(date, "dateChnged");    
  //   updateTimeBasedData(date);
  // }, [date]);

  // const handleDateSelect = (date) => {
  //   if (!date) {
  //     console.error('Invalid date');
  //     return;
  //   }
  //   setDate(date);
  // };
  

  // const result = dataByDuration.map((item,i) => {
  //     const reduceResult = item.result.reduce((acc, curr) => {
  //       const dateOnly = new Date(curr.date).toLocaleString("sv-SE", { timeZoneName: "short" }).split(" ")[0];
  //       acc[dateOnly] = (acc[dateOnly] || 0) + curr.entering;
  //       return acc;
  //     }, {});
  //     let currentDeviceName = deviceNames[i];
  //     return {[deviceNames[i]]:reduceResult}
  // });

  // console.log(result, "resultedData");

  // const formattedResult = result.map((resultItem,i) => {
  //   const locationFormattedResult = Object.entries(resultItem[deviceNames[i]]).map(([date, enteringSum]) => ({
  //     date,
  //     enteringSum
  //   }));
  //   return locationFormattedResult;
  // })

  // console.log(formattedResult, "formattedResultes");
  
  // // chartData.splice(0, chartData.length);

  // const deviceTypes = ["desktop", "mobile", "tablet", "laptop", "ledtv"];
  // const chartData = [];

  // formattedResult[0]?.forEach((_, index) => {
  //   let entry = { month: new Date(formattedResult[0][index].date).toLocaleString('he-is', { day: 'numeric', month: 'short', weekday: 'short' })};
  //   formattedResult.forEach((deviceData, deviceIndex) => {
  //       entry[deviceTypes[deviceIndex]] = deviceData[index]?.enteringSum || 0;
  //   });
  //   chartData.push(entry);
  // });

  // // formattedResult.map((formattedResultItem,i) => {
  // //   const locationData = formattedResultItem.forEach((element,f) => {
  // //     if (i === 0) {
        
  // //       let objToInsert = { month: "", desktop: 0, mobile: 0, tablet: 0, laptop: 0 };
  // //       objToInsert.month = new Date(element.date).toLocaleString('en-us', { day: 'numeric', month: 'short', weekday: 'short' });
  // //       if (i === 0) {
  // //         objToInsert.desktop = element.enteringSum;          
  // //       } else if (i === 1) {
  // //         objToInsert.mobile = element.enteringSum;                    
  // //       } else if (i === 2) {
  // //         objToInsert.tablet = element.enteringSum;                    
  // //       } else if (i === 3) {
  // //         objToInsert.laptop = element.enteringSum;                    
  // //       }
  // //       chartData.push(objToInsert);
  // //     } else {
  // //       console.log(f,chartData, "f");
        
  // //       chartData[f].month = new Date(element.date).toLocaleString('en-us', { day: 'numeric', month: 'short', weekday: 'short' });
  // //       if (i === 0) {
  // //         chartData[f].desktop = element.enteringSum;          
  // //       } else if (i === 1) {
  // //         chartData[f].mobile = element.enteringSum;                    
  // //       } else if (i === 2) {
  // //         chartData[f].tablet = element.enteringSum;                    
  // //       } else if (i === 3) {
  // //         chartData[f].laptop = element.enteringSum;                    
  // //       }
        
  // //     }
  // //   })});

  // console.log(chartData, "chartDataut");

  // console.log( deviceNames, dataByDuration, updateTimeBasedData, "proops");
  
  
  return (
    <Card>
      <CardHeader className="flex items-center gap-2 space-y-0 justify-between border-b py-3 sm:flex-row" >
        <div className="flex flex-col gap-3 max-w-[600px] lg:flex-row" >
          {/* <DatePickerWithRange date={date} setDate={handleDateSelect} /> */}
          <DatePicker calenderComponentDisabled={calenderComponentDisabled} label={"start"} date={calenderStartDate} setDate={handleDateSelect} />
          <DatePicker calenderComponentDisabled={calenderComponentDisabled} label={"end"} date={calenderEndDate} setDate={handleDateSelect} />
          {buttonText && <Button disabled={calenderComponentDisabled} onClick={handleDateSubmit} >{buttonText}</Button>}
        </div>
        {cardTitle || cardDescription ? <div className="grid gap-1 text-right">
          {cardTitle && <CardTitle>{cardTitle}</CardTitle>}
          {cardDescription && <CardDescription>{cardDescription}</CardDescription>}
        </div>:""}
        {/* <DatePickerWithRange /> */}
        {/* <MyDatePicker /> */}
        {/* <Select value={activeMonth} onValueChange={setActiveMonth}>
          <SelectTrigger
            className="w-[160px] rounded-lg sm:ml-auto"
            aria-label="Select a value"
          >
            <SelectValue placeholder="Select month" />
          </SelectTrigger>
          <SelectContent align="end" className="rounded-xl">
            {deviceNames.map((key) => {
              const config = chartConfig[key]

              if (!config) {
                return null
              }

              return (
                <SelectItem
                  key={key}
                  value={key}
                  className="rounded-lg [&_span]:flex"
                >
                  <div className="flex items-center gap-2 text-xs">
                    <span
                      className="flex h-3 w-3 shrink-0 rounded-sm"
                      style={{
                        backgroundColor: `var(--color-${key})`,
                      }}
                    />
                    {key.replace("_", " ")}
                  </div>
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select> */}
      </CardHeader>
      <CardContent>
        <ChartContainer className="aspect-auto h-[303px] w-full" config={chartConfig}>
          <BarChart accessibilityLayer data={chartData} margin={{ top: 30 }}>
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="month"
              tickLine={false}
              tickMargin={10}
              axisLine={false}
              tickFormatter={(value) => value}
            />
            <ChartTooltip content={<ChartTooltipContent
              labelFormatter={(value) => {
                return value;
              }}
              indicator="dot"
            />} />
            <ChartLegend content={<ChartLegendContent />} />
            {chartConfig && Object.keys(chartConfig).map((k, i) => {
              const keys = Object.keys(chartConfig);
              const isLast = i === keys.length - 1;
              return (
                <Bar
                  key={k}
                  dataKey={k}
                  stackId="a"
                  fill={`var(--color-${k})`}
                  radius={i === 0 ? [0, 0, 4, 4] : isLast ? [4, 4, 0, 0] : [0, 0, 0, 0]}
                >
                  {showTotal && isLast && (
                    <LabelList
                      dataKey={k}
                      position="top"
                      content={(props) => (
                        <CustomTotalLabel
                          {...props}
                          chartData={chartData}
                          chartConfig={chartConfig}
                        />
                      )}
                    />
                  )}
                </Bar>
              );
            })}
            {/* <Bar
              dataKey="mobile"
              stackId="a"
              fill="var(--color-mobile)"
              radius={[0, 0, 0, 0]}
            />
            <Bar
              dataKey="tablet"
              stackId="a"
              fill="var(--color-tablet)"
              radius={[0, 0, 0, 0]}
            />
            <Bar
              dataKey="laptop"
              stackId="a"
              fill="var(--color-laptop)"
              radius={[0, 0, 0, 0]}
            />
            <Bar
              dataKey="ledtv"
              stackId="a"
              fill="var(--color-ledtv)"
              radius={[4, 4, 0, 0]}
            /> */}
          </BarChart>
        </ChartContainer>
      </CardContent>
      {/* <CardFooter className="flex-col items-start gap-2 text-sm">
        <div className="flex gap-2 font-medium leading-none">
          Trending up by 5.2% this month <TrendingUp className="h-4 w-4" />
        </div>
        <div className="leading-none text-muted-foreground">
          Showing total visitors for the last 6 months
        </div>
      </CardFooter> */}
    </Card>
  )
}
